export const DISMISSAL_TYPES = [
  { key: 'sem_justa_causa', label: 'Demissão sem justa causa (pela empresa)' },
  { key: 'pedido_demissao', label: 'Pedido de demissão (pelo funcionário)' },
  { key: 'acordo', label: 'Acordo entre as partes' },
]

const monthsBetween = (start, end) => {
  let months =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth())
  if (end.getDate() >= 15) months += 1
  return Math.max(0, months)
}

// Rough estimate only  real payroll math also depends on collective
// agreements, prior unused vacation, and other case-specific factors that
// this simplified calculator doesn't track.
export const calculateClt = ({ salary, admissionDate, dismissalDate, type }) => {
  const admission = new Date(`${admissionDate}T00:00:00`)
  const dismissal = new Date(`${dismissalDate}T00:00:00`)
  if (
    Number.isNaN(admission.getTime()) ||
    Number.isNaN(dismissal.getTime()) ||
    dismissal <= admission
  ) {
    return null
  }

  const dailySalary = salary / 30
  const balanceDays = dismissal.getDate()
  const saldoSalario = dailySalary * balanceDays

  const yearsWorked = Math.floor(
    (dismissal - admission) / (1000 * 60 * 60 * 24 * 365),
  )
  const monthsInVacationPeriod = monthsBetween(
    new Date(dismissal.getFullYear(), 0, 1) > admission
      ? new Date(dismissal.getFullYear(), 0, 1)
      : admission,
    dismissal,
  )
  const monthsSince13thBase = monthsBetween(
    new Date(dismissal.getFullYear(), 0, 1),
    dismissal,
  )

  const feriasProporcionais = (salary / 12) * Math.min(monthsInVacationPeriod, 12)
  const feriasComTerco = feriasProporcionais + feriasProporcionais / 3
  const decimoTerceiro = (salary / 12) * Math.min(monthsSince13thBase, 12)

  const totalMonthsWorked = monthsBetween(admission, dismissal)
  const fgtsEstimado = salary * 0.08 * totalMonthsWorked

  const avisoPrevioDias = Math.min(30 + yearsWorked * 3, 90)
  const avisoPrevioValor = dailySalary * avisoPrevioDias

  let avisoPrevio = 0
  let multaFgts = 0

  if (type === 'sem_justa_causa') {
    avisoPrevio = avisoPrevioValor
    multaFgts = fgtsEstimado * 0.4
  } else if (type === 'acordo') {
    avisoPrevio = avisoPrevioValor / 2
    multaFgts = fgtsEstimado * 0.2
  }

  const total =
    saldoSalario + avisoPrevio + feriasComTerco + decimoTerceiro + multaFgts

  return {
    saldoSalario,
    avisoPrevio,
    feriasProporcionais: feriasComTerco,
    decimoTerceiro,
    multaFgts,
    fgtsEstimado,
    total,
  }
}
